import React from 'react';
import { Link } from 'react-router-dom';
import { truncateString } from '../../lib/methods';
import {attackTableColumns, groupTableColumns} from '../../lib/table_config';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
// import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
// import Checkbox from '@material-ui/core/Checkbox';
// import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
// import DeleteIcon from '@material-ui/icons/Delete';
// import FilterListIcon from '@material-ui/icons/FilterList';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';


const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  
  tableWrapper: {
    overflowX: 'auto',
  },

  tableCell: {
    fontFamily: '"Courier Prime", "Courier", serif',
    fontSize: '1em',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  
  no_results: {
    width: '100%',
    padding: theme.spacing(2),
  },
  
});

class EnhancedTableHead extends React.Component {
  
  render() {
    const { columns } = this.props;
    
    return (
      <TableHead>
        <TableRow>

          {columns.map((column, key) => {
              return (
                <TableCell
                  key={key}
                >
                { column.title }
                </TableCell>
              );
          }, this)}
          
        </TableRow>
      </TableHead>
    );
  }
}

class EnhancedTable extends React.Component {

  handleChangePage = (event, page) => {
    this.props.handleStateUpdate({ page: page });
  };

  handleChangeRowsPerPage = event => {
    this.props.handleStateUpdate({ rowsPerPage: event.target.value });
  };

  render() {
    const { classes, searchTerm, searchType, matches, order, orderBy, rowsPerPage, page, count, loading } = this.props;
    
    const tableColumns = (searchType === 'group') ? groupTableColumns : attackTableColumns;
    
    if (loading) {
      return (
        <LinearProgress />
      );
    } else if (searchTerm === '') {
      return (
        ''
      );
    } else if (matches.length !== 0){
      return (
        <Paper className={classes.root}>
          <TablePagination
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={matches.length}
                columns={tableColumns}
              />
              <TableBody>
              {matches.map((match, row_key) => {
                match.casualties = match.killed + match.injured;
 
                return (
                  <TableRow key={row_key}>
                    {tableColumns.map((column, column_key) => {
                      let link = ( column.link_function && column.link_function(match) ) || null;
                      let field_display;
                      if (link != null) {
                        field_display = 
                          <Link to={{pathname: link}}> 
                            { truncateString( String(match[column.data_field]),  column.max_length)} 
                          </Link>;
                      } else {
                        field_display = 
                          <span>
                            { truncateString( String(match[column.data_field]),  column.max_length)} 
                          </span>;
                      }
                      
                      return (
                        <TableCell className={classes.tableCell} key={column_key}>
                          <Tooltip title={
                            (column.tooltip_field) ? truncateString( String(match[column.tooltip_field]), 1000) : ""
                          }>
                            {field_display}
                          </Tooltip>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
              </TableBody>
            </Table>
          </div>
          
        </Paper>
      );
    }
    else {

      return (
        <Paper className={classes.no_results}>
          <Typography variant="h6">
            No Result Found.
          </Typography>
        </Paper>
      );
    }
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};



export default withStyles(styles)(EnhancedTable);



// WEBPACK FOOTER //
// ./src/Components/Layouts/TableData.js
